import { Link } from "react-router-dom";
import { ArrowRight, Check, Info } from "lucide-react";
import { Reveal } from "./Reveal";

export const ServiceCard = ({ service, index = 0, compact = false }) => (
  <Reveal delay={index * 0.08} className="h-full">
    <article
      data-testid={`service-card-${service.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-3xl border border-slate-100 bg-white shadow-xl shadow-sky-900/5 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-sky-900/10"
    >
      <div className={`relative overflow-hidden ${compact ? "aspect-[16/9]" : "aspect-[16/10]"}`}>
        <img
          src={service.image}
          alt={service.alt}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-navy-900/0 transition-colors duration-500 group-hover:bg-navy-900/10" />
      </div>
      <div className="flex flex-1 flex-col p-7 sm:p-8">
        <h3 className="text-xl font-semibold tracking-tight sm:text-2xl">{service.title}</h3>
        <p className="mt-3 text-sm leading-relaxed sm:text-base">{service.description}</p>
        {!compact && service.items && (
          <ul className="mt-6 grid gap-2.5 sm:grid-cols-2">
            {service.items.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-sm text-slate-600">
                <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" strokeWidth={3} />
                {item}
              </li>
            ))}
          </ul>
        )}
        {!compact && service.note && (
          <p className="mt-5 flex items-start gap-2.5 rounded-xl bg-sky-50 p-4 text-xs leading-relaxed text-sky-900">
            <Info className="mt-0.5 h-4 w-4 shrink-0" />
            {service.note}
          </p>
        )}
        <div className="mt-auto pt-7">
          <Link
            to={`/contact?service=${encodeURIComponent(service.title)}`}
            data-testid={`service-card-${service.id}-cta`}
            className="inline-flex items-center gap-2 font-heading text-sm font-bold text-emerald-600 transition-colors hover:text-emerald-700"
          >
            {service.cta}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </div>
      </div>
    </article>
  </Reveal>
);
